var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeEvery } from "redux-saga/effects";
import { FETCH_RATES_REQUEST, fetchRatesSuccess, fetchRatesFailure } from "../../actions";
import APIIN from "@/utils/APIIN";
const fetchCarrierRates = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.post("/cnvt/shipment", action.payload)
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchCarrierRatesDataWorker(action) {
    var _a, _b, _c, _d, _e;
    try {
        const data = yield call(fetchCarrierRates, action);
        yield put(fetchRatesSuccess(data));
    }
    catch (error) {
        let orderId = "";
        if ((error === null || error === void 0 ? void 0 : error.response) && ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.config) && ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.data)) {
            const parsedData = JSON.parse((_e = (_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.config) === null || _e === void 0 ? void 0 : _e.data);
            orderId = parsedData === null || parsedData === void 0 ? void 0 : parsedData.orderId;
        }
        if (error.response && error.response.data && error.response.data.message) {
            // If error response contains a message, dispatch it
            orderId ? yield put(fetchRatesFailure(Object.assign({ orderId: orderId }, error.response.data))) : yield put(fetchRatesFailure(Object.assign({}, error.response.data)));
        }
        else {
            // If not, dispatch a generic error message
            orderId ? yield put(fetchRatesFailure(Object.assign({ orderId: orderId }, error))) : yield put(fetchRatesFailure(error));
        }
    }
}
export function* watchFetchRatesData() {
    yield takeEvery(FETCH_RATES_REQUEST, fetchCarrierRatesDataWorker);
}
